"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAddressForm = exports.AddressFormProvider = void 0;
var _react = require("react");
var _useAddresses = require("./useAddresses");
var _jsxRuntime = require("react/jsx-runtime");
const addressFormContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const AddressFormProvider = ({
  children,
  ...props
}) => {
  const result = (0, _useAddresses.useAddresses)(props);
  const value = (0, _react.useMemo)(() => result, [result]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(addressFormContext.Provider, {
    value: value,
    children: children
  });
};
exports.AddressFormProvider = AddressFormProvider;
const useAddressForm = () => {
  const ctx = (0, _react.useContext)(addressFormContext);
  if (!ctx) {
    throw new Error('useAddressForm must be used inside AddressFormContextProvider.');
  }
  return ctx;
};
exports.useAddressForm = useAddressForm;